import { cn } from '@quadralize/utils'
import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'
import { LabelWrapper } from '../label/label'

const Slider = React.forwardRef<
  React.ComponentRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    label?: string
    required?: boolean
    error?: boolean
    helperText?: React.ReactNode
  }
>(({ className, label, id, required, error, helperText, ...props }, ref): React.ReactElement => {
  const generatedId = React.useId()
  const sliderId = id || generatedId

  return (
    <LabelWrapper
      label={label}
      id={sliderId}
      required={required}
      error={error}
      helperText={helperText}
    >
      <SliderPrimitive.Root
        id={sliderId}
        ref={ref}
        className={cn('relative flex w-full touch-none select-none items-center', className)}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-bg-muted">
          <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>
        {(props.value || props.defaultValue || [0]).map((_, i) => (
          <SliderPrimitive.Thumb
            /* biome-ignore lint/suspicious/noArrayIndexKey: thumbs are stable and tied to the values array */
            key={`${sliderId}-thumb-${i}`}
            className="block h-5 w-5 rounded-full border-2 border-primary bg-bg-base ring-offset-bg-base transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          />
        ))}
      </SliderPrimitive.Root>
    </LabelWrapper>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
